import { O, pipe } from "@scripts/fp-ts";
import { remsToPx } from "@scripts/util/remsToPx";
import { isServerSide } from "@scripts/util/ssr";

export const getMainNavElement = (): O.Option<HTMLElement> =>
  isServerSide() ? O.none : O.fromNullable(document.body.querySelector(".page-header"));

export const getCurrentMainNavHeight = (defaultNavOffset: number): number =>
  pipe(
    getMainNavElement(),
    O.map((mainNav) => mainNav.getBoundingClientRect().height),
    O.getOrElse(() => defaultNavOffset)
  );

export const calculateNavOffset = (mainNavHeight: number): number =>
  mainNavHeight + remsToPx(1);